export const SHOW_HELP_TEXT_SET = 'character.SHOW_HELP_TEXT_SET';
export const SHOW_HELP_TEXT_SET_REQUEST = 'character.SHOW_HELP_TEXT_SET_REQUEST';
export const ABILITY_SCORE_TYPE_SET_REQUEST = 'character.ABILITY_SCORE_TYPE_SET_REQUEST';
export const ABILITY_SCORE_TYPE_SET_COMMIT = 'character.ABILITY_SCORE_TYPE_SET_COMMIT';
export const STARTING_EQUIPMENT_TYPE_SET = 'character.STARTING_EQUIPMENT_TYPE_SET';
export const STARTING_EQUIPMENT_TYPE_SET_COMMIT = 'character.STARTING_EQUIPMENT_TYPE_SET_COMMIT';
